import { useAuth } from "@babackapp/auth-client/hooks";

/**
 * Returns true if the current viewer has super admin powers,
 * identified by the services.superpowers.activated flag on their user record.
 */
export function useViewerIsSuperAdmin(): boolean {
  const { user } = useAuth();
  return user?.services?.superpowers?.activated ?? false;
}

/** @deprecated Use `useViewerIsSuperAdmin` instead. */
export const useViewerIsBabackTeam = useViewerIsSuperAdmin;
